import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoSirenasComponent } from './listado-sirenas/listado-sirenas.component';
import { MapaSirenasComponent } from './mapa-sirenas/mapa-sirenas.component';
const routes: Routes = [
  { path: '', redirectTo: 'mapa-sirenas', pathMatch: 'full' },
  //Mapa
  {
    path: 'mapa-sirenas',
    title: 'Mapa de botones de pánico',
    component: MapaSirenasComponent,
    canActivate: [],
  },
  {
    path: 'listado-sirenas',
    title: 'Botones de pánico',
    component: ListadoSirenasComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BotonDePanicoRoutingModule {}
